<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Usuário</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form>
             <b-row>
              <b-col cols="6">
                <b-form-group label="CPF:"
                              label-for="cpf">
                  <b-input-group class="mb-6">
                    <b-form-input v-mask="'###.###.###-##'"
                                  id="cpf"
                                  type="text"
                                  :disabled="true"
                                  class="form-control"
                                  placeholder="CPF"
                                  aria-label="CPF"
                                  autocomplete="cpf"
                                  v-model="usuario.cpf"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                 <b-form-group label="Nome:" label-for="input-2">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  id="input-2"
                                  placeholder="Nome"
                                  aria-label="Nome"
                                  autocomplete="nome"
                                  v-model="usuario.nome"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             <b-row>
                <b-col cols="6">
                <b-form-group label="Tipo de Usuário:" label-for="input-3">
                  <b-form-select v-model="usuario.perfil_id" :state="chkState('tipoUsuario')" id="input-3" aria-label="Tipo de usuário"
                                 placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório, e deve ser um endereço
                    de e-mail válido.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
                <b-col cols="6">
                <b-form-group label="E-mail:" label-for="input-4">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  aria-label="E-mail"
                                  id="input-4"
                                  v-model="usuario.email"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
             </b-row>
             <b-row>
                <b-col cols="6">
                    <b-form-group label="Status:">
                        <b-form-radio-group v-model="usuario.ativo" :state="true" id="radio-slots" :options="options" name="radio-options-slots"/>
                    </b-form-group>
                </b-col>
             </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
            <b-button variant="primary" @click="onSubmit"><i class="fa fa-check"></i> Salvar</b-button>
            <b-button variant="primary" @click="modalAlterarSenha = true"><i class="fa fa-key"></i> Alterar Senha</b-button>
            <b-button variant="secondary" @click="$router.go(-1)"><i class="fa fa-mail-reply-all"></i> Voltar</b-button>
        </b-card-footer>
    </b-card>
        <b-modal id="modal-prevent-closing" ref="modal" title="Alterar Senha" ok-title="Salvar" cancel-title="Voltar" v-model="modalAlterarSenha" @show="limparModal" @hidden="limparModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="alterarSenha">
              <b-form-group :state="senhaAtualState" label="Senha Atual:" label-for="senha-atual-input" invalid-feedback="O campo Senha Atual é obrigatório!">
                <b-form-input id="senha-atual-input" type="password" v-model="senhaAtual" :state="senhaAtualState" required></b-form-input>
              </b-form-group>
              <b-form-group :state="senhaNovaState" label="Nova Senha:" label-for="nova-senha-input" invalid-feedback="O campo para Nova Senha é obrigatório!">
                <b-form-input id="nova-senha-input" type="password" v-model="senhaNova" :state="senhaNovaState" required></b-form-input>
              </b-form-group>
              <b-form-group :state="senhaNovaConfirmaState" label="Confirma a Senha:" label-for="confirma-senha-input" invalid-feedback="O campo para Confirmação de senha é obrigatório!">
                <b-form-input id="confirma-senha-input" type="password" v-model="senhaNovaConfirma" :state="senhaNovaConfirmaState" required></b-form-input>
              </b-form-group>
            </form>
        </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  created () {
    if (!this.can('user.update')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('buscarEstados')
      this.$store.dispatch('buscarTipoUsuarios')
      this.$store.dispatch('getUsuario', this.$route.params.id)
      this.$store.dispatch('buscarCidades')
    }
  },
  data () {
    return {
      valueAceiteTipoUsuario: false,
      modalAlterarSenha: false,
      senhaAtual: '',
      senhaNova: '',
      senhaNovaConfirma: '',
      senhaAtualState: null,
      senhaNovaState: null,
      senhaNovaConfirmaState: null,
      options: [
        { text: 'Ativo', value: true },
        { text: 'Inativo', value: false }
      ]
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidades
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    perfilAtual () {
      return this.$store.state.usuario.perfilAtual
    }
  },
  watch: {
    'usuario.estado_id': function () {
      if (this.usuario.estado_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.usuario.estado_id)
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      let data

      data = {
        cpf: this.usuario.cpf.replace(/[^\d]+/g, ''),
        nome: this.usuario.nome,
        email: this.usuario.email,
        email_confirmation: this.usuario.email,
        perfis: JSON.stringify([{ id: this.usuario.perfil_id }]),
        ativo: this.usuario.ativo
      }

      if (this.usuario.perfil_temporario) {
        if (this.usuario.perfil_temporario === 2 && this.usuario.perfil_temporario !== this.perfilAtual) {
          data.situacao = true
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = null
        } else if (this.usuario.perfil_temporario > 2 && this.usuario.perfil_temporario !== this.perfilAtual) {
          data.situacao = false
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = this.usuario.perfil_temporario
        }
      } else {
        if (this.usuario.perfil_id === 2 && this.usuario.perfil_id !== this.perfilAtual) {
          data.situacao = true
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = null
        } else if (this.usuario.perfil_id > 2 && this.usuario.perfil_id !== this.perfilAtual) {
          data.situacao = false
          data.perfis = JSON.stringify([{ id: 2 }])
          data.perfil_temporario = this.usuario.perfil_id
        }
      }

      Vue.http.put('api/usuario/' + this.$route.params.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 4500)
          this.$router.push({path: '/usuarios'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 3500)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    validate () {
      let result = true

      if (!this.usuario.nome) {
        result = false
      }

      if (!this.usuario.email) {
        result = false
      } else if (!this.validateEmail(this.usuario.email)) {
        result = false
      }

      return result
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    chkState (val) {
      switch (val) {
        case 'nome':
          return !!this.usuario.nome
        case 'email':
          if (!this.usuario.email) {
            return false
          } else if (!this.validateEmail(this.usuario.email)) {
            return false
          }
          return !!this.usuario.email
        case 'tipoUsuario':
          let perfil = !!this.usuario.perfil_id

          if (perfil) {
            return true
          }
          return false
        default:
          return false
      }
    },
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.senhaAtualState = !!this.senhaAtual
      this.senhaNovaState = !!this.senhaNova
      this.senhaNovaConfirmaState = !!this.senhaNovaConfirma
      return valid
    },
    limparModal () {
      this.senhaAtual = ''
      this.senhaNova = ''
      this.senhaNovaConfirma = ''
      this.senhaAtualState = null
      this.senhaNovaState = null
      this.senhaNovaConfirmaState = null
    },
    handleOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleSubmit()
    },
    handleSubmit () {
      if (!this.checkFormValidity()) {
        return
      }

      let data

      data = {
        old_password: this.senhaAtual,
        new_password: this.senhaNova,
        new_password_confirmation: this.senhaNovaConfirma
      }

      Vue.http.post('api/usuario/alterarMinhaSenha', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 4500)
          setTimeout(() => this.$router.push({path: '/'}), 3500)
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 3500)
        }
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
      }).catch(e => {
        let response = e.body

        if (response.msg) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.msg, 'Alerta!', 5000)
        }

        if (response.errors) {
          let erros = response.errors

          if (erros.old_password !== undefined) {
            for (let erro of erros.old_password) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Alerta!', 15000)
            }
          }

          if (erros.new_password !== undefined) {
            for (let erro of erros.new_password) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Alerta!', 15000)
            }
          }

          if (erros.new_password_confirmation !== undefined) {
            for (let erro of erros.new_password_confirmation) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro, 'Alerta!', 15000)
            }
          }
        }

        this.limparModal()
      })
    },
    validateEmail: function (email) {
      let re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioEditar.vue